import React from 'react';
import './Auth.css'
import {Route, useNavigate} from 'react-router-dom';
import Login from "./Login";
import Register from "./Register";
import UserDashboard from "./Profile/UserDashboard";
import ResetPassword from "./ResetPassword/ResetPassword";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ProtectedRoute from "../../components/ProtectedRoute";
import AuthCallback from "./AuthCallback";
import { dualStoreRoute } from '../../routes/dualStoreRoute.jsx';

const AuthRoutes = ( selectedLanguage ) => {
    const navigate = useNavigate();

    return (
        <>
            {dualStoreRoute('/:lang/sign-in', (
                <Login selectedLanguage={selectedLanguage} navigate={navigate} />
            ), 'sign-in')}

            {dualStoreRoute('/:lang/sign-up', (
                <Register selectedLanguage={selectedLanguage} navigate={navigate} />
            ), 'sign-up')}

            {dualStoreRoute('/:lang/profile', (
                <ProtectedRoute>
                    <UserDashboard selectedLanguage={selectedLanguage} />
                </ProtectedRoute>
            ), 'profile')}

            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/s/:orgSlug/:storeSlug/auth/callback" element={<AuthCallback />} />

            {dualStoreRoute('/:lang/reset-password', (
                <ResetPassword selectedLanguage={selectedLanguage} navigate={navigate} />
            ), 'reset-password')}

            {dualStoreRoute('/:lang/forgot-password', (
                <ForgotPassword selectedLanguage={selectedLanguage} navigate={navigate} />
            ), 'forgot-password')}
        </>
    );
};

export default AuthRoutes;
